<template>
    <ViewEtudiant/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import ViewEtudiant from "@/components/Etudiant/ViewEtudiant.vue";

    export default defineComponent({
      name: "ViewEtudiantPage",
      components: {
        
        ViewEtudiant,
      },
    });
  </script>